import { Tile } from '@mc/design-system'

import { useTwoPageQRExperiment } from '../hooks'

interface TileLinkWrapperProps {
  control: React.ReactNode
  parentChildren: React.ReactNode
}

export const TileLinkWrapper = ({
  control,
  parentChildren,
}: TileLinkWrapperProps) => {
  const { isEnabled } = useTwoPageQRExperiment()

  if (!isEnabled) return control

  return (
    <div className='d-block mc-corners--sm mc-overflow--hidden'>
      <Tile aspectRatio='9x16'>{parentChildren}</Tile>
    </div>
  )
}
